var _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgELine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#003C8A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    fillOpacity: 0.95
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#003C8A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2283 20.8329C23.043 21.5481 22.6254 22.1815 22.0411 22.6337C21.4567 23.0859 20.7388 23.3312 20 23.3312C19.2612 23.3312 18.5433 23.0859 17.9589 22.6337C17.3746 22.1815 16.957 21.5481 16.7717 20.8329H12.5V19.1663H16.7717C16.957 18.4511 17.3746 17.8177 17.9589 17.3655C18.5433 16.9133 19.2612 16.668 20 16.668C20.7388 16.668 21.4567 16.9133 22.0411 17.3655C22.6254 17.8177 23.043 18.4511 23.2283 19.1663H27.5V20.8329H23.2283V20.8329ZM20 21.6663C20.442 21.6663 20.866 21.4907 21.1785 21.1781C21.4911 20.8655 21.6667 20.4416 21.6667 19.9996C21.6667 19.5576 21.4911 19.1336 21.1785 18.8211C20.866 18.5085 20.442 18.3329 20 18.3329C19.558 18.3329 19.134 18.5085 18.8215 18.8211C18.5089 19.1336 18.3333 19.5576 18.3333 19.9996C18.3333 20.4416 18.5089 20.8655 18.8215 21.1781C19.134 21.4907 19.558 21.6663 20 21.6663Z",
    fill: "#003C8A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgELine);
export default __webpack_public_path__ + "static/media/e-line.125c7777e0f7ba77af5d658ff4e1faac.svg";
export { ForwardRef as ReactComponent };